import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failedMethods = ['El ruido blanco genérico no bloquea las frecuencias de los sonidos de la calle en México.', 'Cansar al bebé de más produce adrenalina, lo que lo mantiene "cableado" y evita el sueño profundo.', 'Los métodos de "extinción" (dejarlo llorar) rompen el anclaje de seguridad sensorial que el bebé necesita para relajar su cerebro.', 'Las ventanas de sueño mal calculadas hacen que pierdas el momento exacto en que la melatonina natural sube.'];
export function FailedMethodsSection() {
  return <section className="w-full bg-[#faf7f2] py-16 md:py-24" data-id="element-3">
      <div className="max-w-4xl mx-auto px-4" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-5">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] text-center mb-12" data-id="element-6">
            ¿Por Qué Lo Que Has Intentado{' '}
            <span className="text-[#ef4444]" data-id="element-7">No Funciona</span>?
          </h2>

          <ul className="space-y-6" data-id="element-8">
            {failedMethods.map((method, index) => <motion.li key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-[#ede5d8]" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-9">
                <XCircleIcon className="w-7 h-7 text-[#ef4444] flex-shrink-0 mt-0.5" data-id="element-10" />
                <p className="font-['DM_Sans'] text-[#334155] text-lg leading-relaxed" data-id="element-11">
                  {method}
                </p>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}